// Soft 5-star review prompt with Fireman Alpha (Max) art.

import React from "react";
import { getCardImageSrc } from "../utils/cardImages";
import characters from "../Characters.json";

const MAX =
    characters.find((card) => /fireman/i.test(String(card.name || ""))) ||
    null;

const REVIEW_LINES = [
    "This is Max.",
    "Max loves the game.",
    "Max gave it 5 stars.",
    "Max is awesome.",
    "Be like Max.",
];

export default function ReviewPromptModal({
    open = false,
    onRate,
    onDismiss,
}) {
    if (!open) {
        return null;
    }

    const imageSrc = MAX ? getCardImageSrc(MAX) : null;

    return (
        <div
            className="reviewPromptOverlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="reviewPromptCopy"
        >
            <div className="reviewPromptPanel">
                {typeof onDismiss === "function" ? (
                    <button
                        type="button"
                        className="reviewPromptPanel__close"
                        aria-label="Close review prompt"
                        onClick={onDismiss}
                    >
                        ×
                    </button>
                ) : null}
                {imageSrc ? (
                    <img
                        className="reviewPromptPanel__hero"
                        src={imageSrc}
                        alt="Max"
                    />
                ) : null}
                <p id="reviewPromptCopy" className="reviewPromptPanel__copy">
                    {REVIEW_LINES.map((line) => (
                        <span key={line} className="reviewPromptPanel__line">
                            {line}
                        </span>
                    ))}
                </p>
                <div className="reviewPromptPanel__actions">
                    <button
                        type="button"
                        className="homePrimaryButton reviewPromptPanel__rate"
                        onClick={onRate}
                    >
                        Rate 5 Stars
                    </button>
                </div>
            </div>
        </div>
    );
}
